import { AxiosResponseModel } from "@/Models/Utils/AxiosResponseModel";
import axios, { AxiosResponse } from "axios";

let options = {
  headers: {
    "api-security-key": "89343EA2-368C-4ABB-90DE-039BE336D2DD",
  },
};

export const Get = async (url: string) => {
  return await axios
    .get(process.env.VUE_APP_API_URL + "/" + url, options)
    .then((res: AxiosResponse<AxiosResponseModel>) => {
      return res;
    });
};

export const Post = async (url: string, payload: object,headers?: { Authorization: string }) => {
  if(headers){
    var header = {
      headers: {
        "api-security-key": "89343EA2-368C-4ABB-90DE-039BE336D2DD",
        "Authorization": `${headers.Authorization}`
      },
    };
    options = header
  }
  return await axios
    .post(process.env.VUE_APP_API_URL + "/" + url, payload, options)
    .then((res: AxiosResponse<AxiosResponseModel>) => {
      return res;
    });
};
export const PostFormData = async (url: string, payload: object) => {
  console.log(process.env.VUE_APP_API_URL,"apiurl")
  var headers = {
    headers: {
      "api-security-key": "89343EA2-368C-4ABB-90DE-039BE336D2DD",
      "Content-Type": "multipart/form-data",
    },
  };

  return await axios
    .post(`${process.env.VUE_APP_API_URL}/${url}`, payload, headers)
    .then((res) => {
      return res;
    });
};
export const PutFormData = async (url: string, payload: object) => {
  console.log(process.env.VUE_APP_API_URL,"apiurl")
  var formHeaders = {
    headers: {
      "api-security-key": "89343EA2-368C-4ABB-90DE-039BE336D2DD",
      "Content-Type": "multipart/form-data",
    },
  };

  return await axios
    .put(`${process.env.VUE_APP_API_URL}/${url}`, payload, formHeaders)
    .then((res) => {
      return res;
    });
};
export const Delete = async (url: any) => {
  return await axios
    .delete(`${process.env.VUE_APP_API_URL}/${url}`, options)
    .then((res) => {
      return res;
    });
};
export const Put = async (url: any, payload: object) => {
  return await axios
    .put(`${process.env.VUE_APP_API_URL}/${url}`, payload, options)
    .then((res) => {
      return res;
    });
};
